"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rsColorPicker = void 0;

var _index = require("../index");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var rsColorPicker = {
  styles: {
    menu: function menu(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        width: 'auto',
        minWidth: 'auto',
        position: 'absolute',
        // display: 'flex',
        marginTop: 0,
        marginBottom: 0,
        padding: '0',
        right: '0',
        border: '1px solid #d1d4e4',
        borderRadius: 3,
        backgroundColor: '#ffffff',
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.1)'
      });
    },
    indicatorSeparator: function indicatorSeparator(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        display: 'none'
      });
    },
    valueContainer: function valueContainer(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        border: '0',
        maxWidth: '0',
        padding: '0',
        opacity: '0'
      });
    },
    control: function control(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        borderWidth: '0',
        boxShadow: '0',
        minHeight: 'auto',
        backgroundColor: 'transparent'
      });
    },
    dropdownIndicator: function dropdownIndicator(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        padding: '0'
      });
    },
    menuList: function menuList(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        maxWidth: '175px',
        width: '175px',
        padding: 0
      });
    },
    option: function option(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        cursor: 'pointer',
        borderRadius: '2px',
        padding: '5px',
        whiteSpace: 'nowrap',
        display: 'flex',
        height: '40px',
        flexWrap: 'nowrap',
        width: 'auto',
        alignItems: 'center'
      });
    }
  },
  components: {
    IndicatorSeparator: function IndicatorSeparator() {
      return null;
    },
    Placeholder: function Placeholder() {
      return null;
    },
    SingleValue: function SingleValue() {
      return null;
    }
  },
  theme: function theme(_theme) {
    return _objectSpread(_objectSpread({}, _theme), {}, {
      borderRadius: 3,
      colors: _objectSpread(_objectSpread({}, _theme.colors), {}, {
        primary25: _index.UI_COLOR_PALE_BLUE,
        primary: _index.UI_COLOR_PALE_BLUE
      })
    });
  }
};
exports.rsColorPicker = rsColorPicker;